import { useCallback } from 'react';

interface UseHomePageScrollParams {
  activeTab: number;
  viewportRef: React.RefObject<HTMLDivElement>;
  chartsViewportRef: React.RefObject<HTMLDivElement>;
}


/**
 * 管理 HomePage 的滚动逻辑
 */
export function useHomePageScroll({
  activeTab,
  viewportRef,
  chartsViewportRef
}: UseHomePageScrollParams) {
  const scrollDown = useCallback(() => {
    console.log('scrollDown 开始执行，当前 activeTab:', activeTab);

    // 根据当前激活的 tab 滚动对应的容器
    if (activeTab === 0) {
      // 投顾应用区域
      if (viewportRef.current) {
        viewportRef.current.scrollTo({
          top: viewportRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    } else if (activeTab === 1) {
      // 图表区域
      if (chartsViewportRef.current) {
        chartsViewportRef.current.scrollTo({
          top: chartsViewportRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }

    // 备用方案：尝试查找所有可见的滚动容器
    setTimeout(() => {
      const visibleScrollContainers = document.querySelectorAll(
        '.overflow-y-auto:not([style*="display: none"])'
      );

      visibleScrollContainers.forEach(container => {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: 'smooth'
        });
      });
    }, 100);
  }, [activeTab, viewportRef, chartsViewportRef]);

  return {
    scrollDown
  };
}
